export default __webpack_public_path__ + "a8f7e82388246996cbb99d52302a1f1b.svg";